<template>
  <b-card
    :class="{
      'mentor-card': true,
      'h-100': true,
      'border-top-0': layout === 'vertical',
      'border-right-0': layout === 'vertical',
      'border-left-0': layout === 'vertical',
    }"
    footer-class="bg-white pb-0 border-0"
    :body-class="{ 'pb-4': layout === 'vertical' }"
  >

    <!-- Mentor details header -->
    <b-row
      :class="{'pt-3': layout !== 'vertical', 'border-bottom': layout !== 'vertical', 'pb-3': layout !== 'vertical', 'px-0': true }"
    >
      <b-col :cols="layout === 'vertical' ? 3 :  12" class="d-flex justify-content-center align-items-center px-0">
        <div class="cxr-avatar d-flex justify-content-center align-items-center col-12" v-if="isCXR">
          <img src="/static/images/avatars/talk-tank-wrapper.png" width="90" height="90" class="wrapper">
          <avatar className="rounded" rounded="1" :user="mentor" :size="layout === 'vertical' ? 36 : 72"/>
        </div>
        <avatar v-else :user="mentor" :size="layout === 'vertical' ? 36 : 72"/>
      </b-col>
      <b-col
        :cols="layout === 'vertical' ? 9 :  12"
        :class="{'pt-3': layout !== 'vertical', 'text-center': layout !== 'vertical', 'px-0': true}">
        <b>{{mentor.fullName}}</b>
        <template
          v-if="interest.location.value || interest.jobTitle.value || interest.businessArea.value || interest.businessArea.value"
          class="my-2"
          style="font-size: 0.8rem !important"
        >
          <br />
          <template v-if="interest.jobTitle.value">
            <span
              :class="{ 'mr-2': true, 'development-tag': interest.jobTitle.isMatch }"
              :style="{ backgroundColor: interest.jobTitle.isMatch ? developmentMatchBG : null }"
              v-b-tooltip.hover :title="interest.jobTitle.tooltip ? interest.jobTitle.tooltip : ''"
            >
              {{ interest.jobTitle.value }}
            </span>
            <br />
          </template>
          <hr v-if="interest.location.value || (interest.businessArea.value && interest.businessArea.value.length) && layout !== 'vertical'" />
          <span
            v-if="interest.location.value && layout !== 'vertical'"
            :class="{ 'mr-2': true, 'development-tag': interest.location.isMatch }"
            :style="{ backgroundColor: interest.location.isMatch ? developmentMatchBG : null }"
            v-b-tooltip.hover :title="interest.location.tooltip ? interest.location.tooltip : ''"
          >
            <font-awesome-icon class="text-muted" icon="map-marker"/> {{ interest.location.value.name }}, {{ interest.location.value.countryCode }}
          </span>
          <span
            v-if="interest.businessArea.value && interest.businessArea.value.length && layout !== 'vertical'"
            :class="{ 'mr-2': true, 'development-tag': interest.businessArea.isMatch }"
            :style="{ backgroundColor: interest.businessArea.isMatch ? developmentMatchBG : null }"
            v-b-tooltip.hover :title="interest.businessArea.tooltip ? interest.businessArea.tooltip : ''"
          >
            <template v-if="typeof interest.businessArea.value === 'string'">
              <font-awesome-icon class="text-muted" icon="briefcase"/> {{ interest.businessArea.value }}
            </template>
            <template v-if="Array.isArray(interest.businessArea.value)">
              <font-awesome-icon class="text-muted" icon="briefcase"/> {{ interest.businessArea.value.join(', ') }}
            </template>
          </span>
        </template>
      </b-col>
    </b-row>

    <!-- Mentor skills section -->
    <b-row class="py-3">
      <!-- b-col v-if="layout !== 'vertical'" cols="12" class="pb-2 text-center text-muted">
        {{$root.isCXR ? 'Mentor Discliplines' : 'Mentor Skills'}}
      </b-col -->
      <b-col cols="12" :class="{'text-center': layout !== 'vertical'}">
        <span
        class="skill-tag mr-1 mt-1"
        v-for="skill in skills"
        :style="{ backgroundColor: skill.background, color: skill.isMatch && $root.isCXR ? '#fff' : undefined }"
        :key="skill.name"
        v-b-tooltip.hover :title="skill.tooltip ? skill.tooltip : ''"
      >{{ skill.name }}</span>
      </b-col>
    </b-row>

    <!-- Mentor buttons section if vertical -->
    <b-row v-if="layout === 'vertical'">
      <b-col>
        <b-button
          v-if="!(mentor.mentorRequest && mentor.mentorRequest.status)"
          variant="primary"
          v-b-modal="`mentor-contact-${mentor.id}`"
          size="sm"
          block
        >{{isCXR ? 'Connect' : 'Contact'}}</b-button>
        <div
          v-else
          class="request-status py-1"
          :style="{
            color: requestStatus(mentor.mentorRequest.status).color,
            borderColor: requestStatus(mentor.mentorRequest.status).color,
          }"
          v-b-modal="`mentor-request-${mentor.id}`"
        >
          {{ requestStatus(mentor.mentorRequest.status).name }}
        </div>
      </b-col>
      <b-col class="pt-2">
        <b-link v-b-modal="`mentor-profile-${mentor.id}`">View Profile</b-link>
      </b-col>
    </b-row>

    <!-- Mentor buttons section if default -->
    <template v-else slot="footer">
      <b-row class="pb-3 border-bottom">
        <b-col class="text-center">
          <b-button
            v-if="!(mentor.mentorRequest && mentor.mentorRequest.status)"
            variant="primary"
            v-b-modal="`mentor-contact-${mentor.id}`"
            block
          >{{isCXR ? 'Connect' : 'Contact Mentor'}}</b-button>
          <div
            v-else
            class="request-status py-2"
            :style="{
              color: requestStatus(mentor.mentorRequest.status).color,
              borderColor: requestStatus(mentor.mentorRequest.status).color,
            }"
            v-b-modal="`mentor-request-${mentor.id}`"
          >
            {{ requestStatus(mentor.mentorRequest.status).name }}
          </div>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <b-col class="text-center">
          <b-link v-b-modal="`mentor-profile-${mentor.id}`">View Profile</b-link>
        </b-col>
      </b-row>
    </template>

    <!-- Mentor Profile Modal -->
    <b-modal
      :id="`mentor-profile-${mentor.id}`"
      title="Profile"
      body-class="gray-bg"
      hide-footer
      lazy
    >
      <profile-show
        :user="mentor"
        @contactMentor="$bvModal.show(`mentor-contact-${mentor.id}`)"
        layout="mentor"
      />
    </b-modal>

    <!-- Contact Mentor Modal -->
    <b-modal
      :id="`mentor-contact-${mentor.id}`"
      title="Contact Mentor"
      body-class="gray-bg"
      size="lg"
      hide-footer
      lazy
    >
      <contact-mentor-form
        :mentor="mentor"
        :jobTitle="interest.jobTitle.value"
        :skills="skills"
        :skillBG="tagBG"
        :selectedSkillBG="matchBG"
        @submitContactMentorRequest="($event) => $emit('submitContactMentorRequest', $event)"
        @closeModal="$bvModal.hide(`mentor-contact-${mentor.id}`)"
      />
    </b-modal>

    <!-- Mentor Request Details Modal -->
    <b-modal
      v-if="mentor.mentorRequest && mentor.mentorRequest.status"
      :id="`mentor-request-${mentor.id}`"
      title="Mentor Request"
      body-class="gray-bg"
      size="lg"
      hide-footer
      lazy
    >
      <mentor-request-details
        :mentor="mentor"
        :jobTitle="interest.jobTitle.value"
        :skills="skills"
        :skillBG="tagBG"
        :status="requestStatus(mentor.mentorRequest.status).name"
        :mentorRequest="mentor.mentorRequest"
      />
    </b-modal>

  </b-card>
</template>

<script>
import Avatar from '@/components/users/Avatar';
import tinycolor from 'tinycolor2';

import ProfileShow from '@/components/profile/ProfileShow';
import ContactMentorForm from '@/components/mentors/ContactMentorForm';
import MentorRequestDetails from '@/components/mentors/MentorRequestDetails.vue';
import { mapRoot } from '@src/mixins/root';
import { parseIfPossible } from '@src/lib/imMatching';

const mentorRequestStatuses = {
  'REQUESTED': {
    name: 'Pending',
    color: '#6c757d',
  },
  'ACTIVE': {
    name: 'Active',
    color: '#28a745',
  },
  'INACTIVE': {
    name: 'Inactive',
    color: '',
  },
  'REJECTED': {
    name: 'Rejected',
    color: '#dc3545',
  },
};

export default {
  components: {
    Avatar,
    ProfileShow,
    ContactMentorForm,
    MentorRequestDetails,
  },
  props: {
    mentor: {
      type: Object,
      default: () => null
    },
    layout: {
      type: String,
      default: 'default',
    },
    job: {
      type: Object,
      default: () => null,
    }
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isCXR' ]),
    interest() {
      const { mentor, mentorJobTitle, mentorJobBusinessAreas, mentorLocation } = this;
      const hasInterestMatches = mentor.imMatchingDetails &&
          Array.isArray(mentor.imMatchingDetails.interestData) &&
          mentor.imMatchingDetails.interestData.length;
      const matches = hasInterestMatches ? mentor.imMatchingDetails.interestData : [];

      return {
        location: {
          value: mentorLocation,
          isMatch: !!matches.find(({ type }) => type === 'JOB_LOCATION'),
          tooltip: this.getTooltip(matches.find(({ type }) => type === 'JOB_LOCATION')),
        },
        businessArea: {
          value: mentorJobBusinessAreas,
          isMatch: !!matches.find(({ type }) => type === 'JOB_BUSINESS_AREA'),
          tooltip: this.getTooltip(matches.find(({ type }) => type === 'JOB_BUSINESS_AREA')),
        },
        jobTitle: {
          value: mentorJobTitle,
          isMatch: !!matches.find(({ type }) => type === 'JOB_TITLE'),
          tooltip: this.getTooltip(matches.find(({ type }) => type === 'JOB_TITLE')),
        },
      };
    },
    mentorJobTitle() {
      if (this.isCXR) {
        const { customFields: mentorCustomFields } = this.mentor;
        const title = Array.isArray(mentorCustomFields)
          ? mentorCustomFields.find(c => c && c.key === 'CURRENTMOST-RECENT-JOB-TITLE-621792')
          : null;
        return title && title.value ? title.value : null;
      } else {
        return this.getMentorFieldValue('JOB_TITLES', 'skills');
      }
    },
    mentorJobBusinessAreas() {
      const mentorSkillBusinessAreas = parseIfPossible(this.getMentorFieldValue('JOB_BUSINESS_AREA', 'skills'));
      const mentorMentorshipBusinessAreas = parseIfPossible(this.getMentorFieldValue('JOB_BUSINESS_AREA', 'mentorship'));
      const mentorBusinessAreasRaw = mentorMentorshipBusinessAreas || mentorSkillBusinessAreas;
      if (typeof mentorBusinessAreasRaw === 'string') {
        return [ mentorBusinessAreasRaw ];
      }
      return Array.isArray(mentorBusinessAreasRaw) ? mentorBusinessAreasRaw : [];
    },
    mentorLocation() {
      const mentorLocation = parseIfPossible(this.getMentorFieldValue('LOCATION', 'skills'));
      return mentorLocation && Array.isArray(mentorLocation.location) ? mentorLocation.location[0] : null;
    },
    skills() {
      const { mentor, matchBG, tagBG, developmentMatchBG, layout } = this;
      const mentorSkills = this.parseIfPossible(this.getMentorFieldValue('JOB_SKILLS', 'mentorship'));
      console.log('MATCHING DETAILS: ', mentor.imMatchingDetails);
      if (Array.isArray(mentorSkills) && mentorSkills.length) {
        const hasSkillMatches = mentor.imMatchingDetails &&
          Array.isArray(mentor.imMatchingDetails.skillsData) &&
          mentor.imMatchingDetails.skillsData.length;
        let skills = mentorSkills.map(skill => {
          const matchDetails = hasSkillMatches ? mentor.imMatchingDetails.skillsData.find(el => skill === el.value) : null;
          // const jobMatchDetails = this.job ? ... : null;
          return {
            isMatch: !!matchDetails,
            background: matchDetails ? (this.$root.isCXR ? matchBG : developmentMatchBG) : tagBG,
            name: skill,
            score: matchDetails ? matchDetails.score : 0,
            tooltip: this.getTooltip(matchDetails),
          };
        }).sort((a, b) => b.score - a.score);
        const skillsCount = layout === 'vertical' ? 3 : 5;
        skills = skills.length > skillsCount ? [
          ...skills.slice(0, skillsCount - 1),
          { isMatch: false, background: tagBG, score: 0, tooltip: null, name: `+${skills.length - skillsCount}` }
        ] : skills;
        return skills;
      }
      return null;
    },
    tagBG() {
      return '#eee';
    },
    matchBG() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(20).toString() : '#eee';
    },
    matchColor() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? siteBranding.primaryColour : '#000';
    },
    developmentMatchBG() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(42).toString() : '#eee';
    },
  },
  methods: {
    getTooltip(matchDetails) {
      if (matchDetails && matchDetails.type) {
        if (matchDetails.type === 'SKILL') {
          return 'Direct match with one of your skills.';
        } else if (matchDetails.type === 'JOB_TITLE') {
          return 'Matches with a job title you are interested in.';
        } else if (matchDetails.type === 'JOB_BUSINESS_AREA') {
          return 'Matches with a business area title you are interested in.';
        } else if (matchDetails.type === 'JOB_SENIORITY') {
          return 'Matches with a job seniority level you are interested in.';
        } else if (matchDetails.type === 'JOB_LOCATION') {
          return 'Matches with a location you are interested in.';
        }
      }
      return null;
    },
    getMentorFieldValue(type, group) {
      const { company: { customFields }, mentor: { customFields: mentorCustomFields } } = this;
      if (Array.isArray(customFields) && customFields.length && Array.isArray(mentorCustomFields)) {
        const field = customFields.find(el => el.type === type && el.group === group);
        const fieldKey = field ? field.key : null;
        const mentorField = fieldKey ? mentorCustomFields.find(({ key }) => key === fieldKey) : null;
        return mentorField ? mentorField.value : null;
      }
      return null;
    },
    getUserFieldValue(type, group) {
      const { company: { customFields }, user: { customFields: userCustomFields } } = this;
      if (Array.isArray(customFields) && customFields.length && Array.isArray(userCustomFields)) {
        const field = customFields.find(el => el.type === type && el.group === group);
        const fieldKey = field ? field.key : null;
        const userField = fieldKey ? userCustomFields.find(({ key }) => key === fieldKey) : null;
        return userField ? userField.value : null;
      }
      return null;
    },
    parseIfPossible(value) {
      try {
        value = JSON.parse(value);
      } catch (e) {
        // not a json
      }
      return value;
    },
    requestStatus(requestStatus) {
      return mentorRequestStatuses[requestStatus];
    },
  },
};
</script>

<style lang="scss">
.mentor-card {
  .skill-tag {
    display: inline-block;
    font-size: 13px;
    padding: 3px 6px;
    border-radius: 2px;
  }
  .request-status {
    border: 1px solid #ddd;
    text-align: center;
    border-radius: 3px;
    cursor: pointer;
  }
  .development-tag {
    position: relative;
    display: inline-block;
    padding: 3px 10px;
    border-radius: 2px;
  }

  .cxr-avatar {
    position: relative;

    img.wrapper {
      position: absolute;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mentors/MentorItem.vue